module.exports = "/assets/packs/images/7239a98fbe9951a2687674f04bb24fa7.svg";